import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import styles from '../PrivacyPolicyContents.module.css';

const PrivacyPolicyContentsOld = () => {
  return (
    <Container>
      <div className={styles.tncTitle}>개인정보 처리방침</div>
      <Row>
        <Col>
          <div>
            <p>
              <center>
                <div className={styles.title}>
                  2021년 2월 18일자로 <a href='/privacypolicy'>신규 개인정보 처리방침</a>이 적용됩니다.
                </div>
              </center>
            </p>

            <p>
              <div className={styles.title}>2020년 8월 7일 개정</div>
            </p>
            <p>
              주식회사 까리용(이하 “회사”라 합니다; 이하 개인정보 처리방침에서 “”을 사용하여 표기한 용어는 약관에서
              사용된 예와 같습니다)은 “이용자”의 개인정보 보호를 중시하며, 개인정보 보호법, 정보통신망 이용촉진 및
              정보보호 등에 관한 법률 등 관련 법령상의 개인정보 보호 규정을 준수하고 있습니다. “회사”는 다음과 같이
              개인정보처리방침을 명시하여 “이용자”가 “회사”에 제공한 개인정보가 어떠한 용도와 방식으로 이용되고 있으며
              개인정보보호를 위해 어떠한 조치를 취하는지 알려드립니다.
            </p>
            <p>
              <div className={styles.title}>1. 개인정보의 수집 및 이용 목적</div>
            </p>
            <p>(1) 회원 관리</p>
            <p>
              회원제 서비스 이용에 따른 본인확인, 개인식별, 불량회원의 부정 이용 방지와 비인가 사용 방지, 가입 의사
              확인, 가입 및 가입횟수 제한, 만14세 미만 미성년자 개인정보 수집 시 법정대리인 동의여부 확인, 추후
              법정대리인 본인확인, 분쟁 조정을 위한 기록보존, 불만처리 등 민원처리, 고지사항 전달, 회원탈퇴 의사의 확인
            </p>
            <p>(2) “사이트” 내 서비스 제공 및 그에 따른 요금정산</p>
            <p>“사이트” 내 서비스 제공, 대금 결제, 대금 추심</p>
            <p>(3) 신규 서비스 개발, 기능 개선, 마케팅 및 광고에 활용</p>
            <p>
              신규 서비스 개발 및 특화, 맞춤형 서비스 제공, 기능 개선, 접속 빈도 파악, 회원의 서비스 이용에 대한 통계,
              인구통계학적 특성과 이용자의 관심, 기호, 성향의 추정을 통한 맞춤형 컨텐츠 추천 및 마케팅에 활용, 이벤트 등
              광고성 정보 제공 및 이벤트 참여 기회 제공
            </p>
            <p>
              <div className={styles.title}>2. 수집하는 개인정보</div>
            </p>

            <p>
              <div className={styles.paragraph}>(1) “회원” 가입 시</div>
            </p>
            <p>
              <div className={styles.paragraph}>① 필수정보(기본적인 서비스를 제공하기 위해 수집하는 개인정보)</div>
            </p>
            <p>
              <div className={styles.paragraph}>
                - 아이디, 비밀번호, 이름, 이메일 주소, 휴대전화번호, (“회원”으로 가입하려는 자가 만14세 미만 미성년자인
                경우)법정대리인 정보(법정대리인의 이름, 생년월일, 중복가입확인정보(DI), 휴대전화번호)
              </div>
            </p>
            <p>
              <div className={styles.paragraph}>
                ② 선택정보(기본적인 서비스 이외에 부가적인 서비스를 제공하기 위해 수집하는 개인정보)
              </div>
            </p>
            <p>
              <div className={styles.paragraph}>
                - 생년월일, 직업, 직장명, 사법연수원 수료 기수· 변호사시험 합격 기수(“회원”으로 가입하려는 자가 변호사인
                경우), 프로필 정보
              </div>
            </p>
            <p>
              <div className={styles.paragraph}>(2) “이용자”가 “사이트”를 이용하는 과정</div>
            </p>
            <p>
              <div className={styles.paragraph}>
                - IP 주소, 쿠키, MAC 어드레스, 서비스 이용 기록, 기기정보, 위치정보
              </div>
            </p>
            <p>
              <div className={styles.paragraph}>
                - 이와 같이 수집된 정보는 개인정보와의 연계 여부 등에 따라 개인정보에 해당할 수 있고, 개인정보에
                해당하지 않을 수도 있고, 본 개인정보 처리방침은 위 정보 중 개인정보가 아닌 정보에는 적용되지 않습니다.
              </div>
            </p>
            <p>(3) 유료 결제 시</p>
            <p>① 신용카드 결제 시: 카드번호, 카드사 명 등</p>
            <p>② 휴대전화번호 결제 시: 휴대전화번호, 결제승인번호 등</p>
            <p>③ 계좌이체 시: 예금주 명, 계좌번호, 계좌 은행 명 등</p>
            <p>(4) 현금영수증 발행 시</p>
            <p>- 휴대폰번호, 현금영수증 카드번호</p>
            <p>
              <div className={styles.title}>3. 개인정보의 수집 방법</div>
            </p>
            <p>
              - 회원가입 및 서비스 이용 과정에서 이용자가 개인정보 수집에 대해 동의를 하고 직접 정보를 입력하는 경우,
              해당 개인정보를 수집합니다.
            </p>
            <p>
              - 고객센터를 통한 상담 또는 “사이트” 서비스 관련 문의나 요청 과정에서 “이용자”의 개인정보가 수집될 수
              있습니다.
            </p>
            <p>- 오프라인에서 진행되는 이벤트, 세미나 등에서 서면을 통해 개인정보가 수집될 수 있습니다.</p>
            <p>- “회사”와 제휴한 외부 기업이나 단체로부터 개인정보를 제공받을 수 있습니다.</p>
            <p>- 기기정보와 같은 생성정보는 “사이트” 이용 과정에서 자동으로 생성되어 수집될 수 있습니다.</p>
            <p>
              <div className={styles.title}>4. 개인정보의 제공 및 위탁</div>
            </p>
            <p>“회사”는 다음의 경우가 아니면 “이용자”의 개인정보를 제3자에 제공하지 않습니다.</p>
            <p>(1) 정보주체로부터 별도의 동의를 받는 경우</p>
            <p>(2) 다른 법률에 특별한 규정이 있는 경우</p>
            <p>
              (3) 정보주체 또는 그 법정대리인이 의사표시를 할 수 없는 상태에 있거나 주소불명 등으로 사전 동의를 받을 수
              없는 경우로서 명백히 정보주체 또는 제3자의 급박한 생명, 신체, 재산의 이익을 위하여 필요하다고 인정되는
              경우
            </p>
            <p>
              (4) 통계작성 및 학술연구 등의 목적을 위하여 필요한 경우로서 특정 개인을 알아볼 수 없는 형태로 개인정보를
              제공하는 경우
            </p>
            <p>(5) 범죄의 수사와 공소의 제기 및 유지를 위하여 필요한 경우</p>
            <p>(6) 법원의 재판업무 수행을 위하여 필요한 경우</p>
            <p>(7) 형 및 감호, 보호처분의 집행을 위하여 필요한 경우</p>
            <p>
              <div className={styles.title}>5. 개인정보의 처리 및 보유 기간</div>
            </p>
            <p>
              “회사”는 원칙적으로 수집한 개인정보를 수집 및 이용목적이 달성되면 지체없이 전자적 파일형태로 저장된
              개인정보는 복원이 불가능한 방법으로 영구 삭제하고, 종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각하여
              파기합니다. 다만, “회사”는 다음과 같은 경우 별도 기간 개인정보를 보관합니다.
            </p>
            <p>(1) “이용자”로부터 개인정보 보관기간에 대해 별도의 동의를 얻은 경우</p>
            <p>(2) 법령에서 일정 기간 보관 의무를 부과하는 경우</p>
            <p>① 전자상거래 등에서 소비자 보호에 관한 법률</p>
            <p>- 계약 또는 청약철회 등에 관한 기록: 5년 보관</p>
            <p>- 대금결제 및 재화 등의 공급에 관한 기록: 5년 보관</p>
            <p>- 소비자의 불만 또는 분쟁처리에 관한 기록: 3년 보관</p>
            <p>② 전자금융거래법</p>
            <p>- 전자금융에 관한 기록: 5년 보관</p>
            <p>③ 통신비밀보호법</p>
            <p>- 로그인 기록: 3개월</p>
            <p>
              <div className={styles.title}>6. 정보주체와 법정대리인의 권리·의무 및 그 행사방법</div>
            </p>
            <p>
              (1) “이용자”는 legal@legalengine.co.kr로 전자우편을 보내 개인정보 보호법 및 관계 법령에 따른 권리를 행사할
              수 있습니다.
            </p>
            <p>(2) “회원”은 언제든지 회원탈퇴를 통해 개인정보 수집 및 이용 동의를 철회할 수 있습니다.</p>
            <p>
              (3) 만 14세 미만인 “이용자”의 법정대리인은 당해 “이용자” 개인정보를 조회하거나 수정할 수 있으며 가입해지를
              요청할 수도 있습니다.
            </p>
            <p>
              <div className={styles.title}>7. 개인정보 보호 책임자</div>
            </p>
            <p>
              “회사”는 “이용자”의 개인정보 관련 문의사항 및 불만 처리 등을 위하여 아래와 같이 개인정보 보호책임자를
              지정하고 있습니다.
            </p>
            <p>이름: 오경원</p>
            <p>직위: 대표이사</p>
            <p>전자우편 주소: legal@legalengine.co.kr</p>
            <p>전화번호: 070-4616-3321</p>
            <p>
              <div className={styles.title}>8. 개인정보 자동수집 장치의 설치·운영 및 그 거부에 관한 사항</div>
            </p>
            <p>
              “이용자”에게 개인화되고 맞춤화된 서비스를 제공하기 위해서 “회사”는 “이용자”의 정보를 저장하고 수시로
              불러오는 '쿠키(cookie)'를 사용합니다. 쿠키는 웹사이트를 운영하는데 이용되는 서버가 사용자의 브라우저에게
              보내는 조그마한 데이터 꾸러미로 “이용자” 컴퓨터의 하드디스크에 저장됩니다.
            </p>
            <p>(1) 쿠키 사용목적</p>
            <p>
              “이용자”의 접속 빈도나 방문 시간 등의 분석, 이용자의 취향과 관심분야의 파악 및 자취 추적, 각종 이벤트 참여
              정도 및 방문 회수 파악 등을 통한 타겟 마케팅 및 개인 맞춤 서비스 제공
            </p>
            <p>(2) 쿠키 설정 거부 방법</p>
            <p>
              쿠키에는 이름, 전화번호 등 개인을 식별하는 정보를 저장하지 않고, “이용자”는 쿠키 설치에 대한 선택권을
              가지고 있습니다. 따라서 “이용자”는 웹 브라우저에서 옵션을 설정함으로써 모든 쿠키를 허용하거나, 쿠키가
              저장될 때마다 확인을 거치거나, 모든 쿠키의 저장을 거부할 수도 있습니다. 다만, 쿠키 설치를 거부할 경우 웹
              사용이 불편해지며, 로그인이 필요한 일부 서비스 이용에 어려움이 있을 수 있습니다.
            </p>
            <p>(3) 쿠키 설정 거부 방법 예</p>
            <p>
              ① 인터넷 익스플로어의 경우: 웹 브라우저 상단의 도구 &#62; 인터넷 옵션 &#62; 개인정보 &#62; 고급에서 설정
            </p>
            <p>
              ② 웹 브라우저 우측의 설정 메뉴 &#62; 화면 하단의 고급 설정 표시 &#62; 개인정보의 콘텐츠 설정 버튼 &#62;
              쿠키
            </p>
            <p>
              <div className={styles.title}>9. 개인정보의 안전성 확보 조치</div>
            </p>
            <p>(1) “회사”는 개인정보에 대한 접근권한이 있는 사람을 최소화하고 있습니다.</p>
            <p>(2) 기술적 조치: 중요 개인 정보의 암호화, 개인정보 보관하는 시스템 접근권한 관리, 접근통제시스템 설치</p>
            <p>
              <div className={styles.title}>10. 개인정보 처리방침의 개정과 개정 전 고지</div>
            </p>
            <p>
              “회사”의 개인정보처리방침은 법령의 변경 또는 “회사”의 약관 및 내부 정책에 따라 변경될 수 있습니다.
              개인정보처리방침이 변경되는 경우 “회사”는 변경 사항을 게시하며, 변경된 개인정보처리방침은 게시한 날로부터
              7일 후부터 효력이 발생합니다. 다만, 이용자의 권리 또는 의무에 중요한 내용의 변경이 있을 경우에는 최소
              30일전에 고지합니다.
            </p>
            <p>공고일자: 2020년 7월 30일</p>
            <p>시행일자: 2020년 8월 7일</p>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default PrivacyPolicyContentsOld;
